import React from 'react'
import { Row, Col, Accordion, Card } from 'react-bootstrap';
import { toMonetaryFormat } from '../../common/Utilities';

function ExternalCost({
  externalCost,
  onChangeExternalCost,
  showInvalidAlert, 
  readOnly 
}) {
  return (
    <Accordion defaultActiveKey="1" className="mt-3">
      <Card>
        <Accordion.Toggle as={Card.Header} eventKey="1">
          <b>Other Costs</b>
        </Accordion.Toggle>
          <Card.Body>
            <Row>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className="float-right">
                  <input type="text" 
                    className="num-input" 
                    disabled={readOnly ? true : false}
                    id="project_external_cost" 
                    defaultValue={externalCost > 0 ? toMonetaryFormat(externalCost) : ''} 
                    onFocus={() => {
                      let projectExtCost = document.getElementById('project_external_cost');
                      projectExtCost.value = projectExtCost.value.replace(/,/g, '');
                    }}
                    onBlur={(e) => { 
                      let projectExtCost = document.getElementById('project_external_cost');
                      if (isNaN(e.target.value)) {
                        showInvalidAlert('Invalid external cost.');
                        projectExtCost.value = "";
                      }
                      else {
                        onChangeExternalCost(e);
                        const extValue = toMonetaryFormat(parseFloat(projectExtCost.value));
                        projectExtCost.value = extValue;
                      }
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Card.Body>
      </Card>
    </Accordion>
  )
}

export default ExternalCost
